import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from '../../../../services/header/header.service';
import { ExportService } from '../../shared/export.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ticket-caisse',
  templateUrl: './ticket-caisse.component.html',
  styleUrls: ['./ticket-caisse.component.scss']
})
export class TicketCaisseComponent implements OnInit {
    currentStatus: string = 'tous';
    statuses: string[] = ['tous', 'disponible', 'consolide', 'facture_client', 'avoire', 'annule'];

    /** Compteurs optionnels par statut (ex. onglet Annulé). */
    counts: Record<string, number> = {};


    currentUser: any = null;
    userId: number | null = null;
    stationId: number | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private headerService: HeaderService,
        private exportService: ExportService,
        private toastr: ToastrService
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        this.userId = this.currentUser?.id || null;
        this.stationId = this.currentUser?.stations?.[0]?.id || null;
    }

    ngOnInit(): void {
        this.headerService.setConfig({
            title: 'Ticket caisse',
            buttons: [
                {
                    label: 'Exporter',
                    type: 'dropdown',
                    dropdownItems: [
                        {
                            label: 'PDF',
                            action: () => this.exportService.triggerPDF(),
                            icon: '../../../assets/images/logo/pdf_logo.png'
                        },
                        {
                            label: 'CSV',
                            action: () => this.exportToCSV(),
                            icon: '../../../assets/images/logo/csv_logo.png'
                        }
                    ]
                }
            ]
        });
        this.route.firstChild?.url.subscribe(segments => {
            const path = segments.length > 0 ? segments[0].path : 'tous';
            this.currentStatus = path.toLowerCase();
        });
    }

    filterByStatus(status: string) {
        this.currentStatus = status.toLowerCase();
        const mappedStatus = this.mapPathToStatus(status);


        this.router.navigate([`/tiers/ticketCaisse/${status.toLowerCase()}`]);
    }


    private mapPathToStatus(path: string): string {
        const statusMap: { [key: string]: string } = {
            tous: 'Tous',
            disponible: 'Disponible',
            consolide: 'Consolidé',
            facture_client: 'Facture client',
            avoire: 'Avoiré',
            annule: 'Annulé'
        };
        return statusMap[path.toLowerCase()] || 'Tous';
    }

    private exportToCSV(): void {
     //   const data = this.dataService.getQuoteTableData();
        const headers = ['Référence', 'Client', 'Date', 'Revenu', 'Matricule', 'Statut'];

       // const csvContent = headers.join(',') + '\n' + rows.map(row => row.join(',')).join('\n');
     //   this.exportService.downloadCSV(csvContent, 'devis.csv');
    }

}
